import { AppConfig } from "@config/config";
import { AyolApiClient } from "./AyolApiClient";

export const ayolApiClient = new AyolApiClient({ baseUrl: AppConfig.AyolApiUrl });
